<template>
  <section>
    <video muted autoplay playsinline @ended="routeHome">
      <source src="../assets/video/crash_video_02.mp4" type="video/mp4" />
    </video>
  </section>
</template>

<script>
export default {
  name: "Crash",
  methods: {
    routeHome() {
      this.$router.push({ path: `/home` });
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #000;
}
video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: cover;
  z-index: 1;
}
</style>